export enum AuthenticationMethodsEnum {
  EMAIL = 'EMAIL',
  MAGIC_LINK = 'MAGIC_LINK',
  PASSWORD_RESET = 'PASSWORD_RESET',
}
